// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xmOwiih3GZMFe6m4 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 97px;
  min-height: calc(100vh - 97px);
  position: relative;
}

.xPiIdQxkhiEsHj48 {
  justify-content: center;
}

@media screen and (max-width: 1360px) {
  .xPiIdQxkhiEsHj48 {
    background: none !important;
    justify-content: unset;
    min-height: calc(100vh - 97px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/StudentPortal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;EAChC;AACF","sourcesContent":[".wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  margin-top: 97px;\r\n  min-height: calc(100vh - 97px);\r\n  position: relative;\r\n}\r\n\r\n.closedPage {\r\n  justify-content: center;\r\n}\r\n\r\n@media screen and (max-width: 1360px) {\r\n  .closedPage {\r\n    background: none !important;\r\n    justify-content: unset;\r\n    min-height: calc(100vh - 97px);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `xmOwiih3GZMFe6m4`;
export var closedPage = `xPiIdQxkhiEsHj48`;
export default ___CSS_LOADER_EXPORT___;
